import { ICategory, IStation, IType } from "@models"
import stationsMap from "./stationsMap.json"
import { TOP_AMOUNT } from "@lib/helpers"

const map = JSON.parse(JSON.stringify(stationsMap)) as { [key: string]: IStation }
const arr = Object.values(map).sort((a, b) => a.order - b.order) as IStation[]

let categories: { [key in ICategory]?: string[] } = {}

const _export = {
    getStationsArr: () => arr,
    getStationsMap: () => map,
    getCategories: () => {
        if (Object.keys(categories).length > 0)
            return categories
        const cats: typeof categories = {
            top: arr.slice(0, TOP_AMOUNT).map(s => s.id),
            favorites: []
        }
        arr.forEach(station => {
            for (const category of station.categories) {
                if (!cats[category])
                    cats[category] = [station.id]
                else
                    cats[category].push(station.id)
            }
        })
        categories = {
            ...categories,
            ...cats
        }
        return categories
    },
    getByCategory: (cat: ICategory): IStation[] => {
        return arr.filter(station => station.categories.includes(cat))
    },
    getByType: (type: IType): IStation[] => {
        return arr.filter(station => station.type === type)
    },
    getByID: (id?: string): IStation | null => {
        if (!id) return null
        return map[id]
    },
    /** Same-network siblings, in site order. Ids that don't resolve are dropped
     *  rather than thrown on: a typo'd or retired id should cost one row, not
     *  the whole station page. Self-references are dropped for the same reason. */
    getRelated: (id?: string): IStation[] => {
        if (!id) return []
        const station = map[id]
        if (!station?.related?.length) return []
        return station.related
            .filter(relatedId => relatedId !== id)
            .map(relatedId => map[relatedId])
            .filter(Boolean)
            .sort((a, b) => a.order - b.order)
    }
}
export default _export